import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

const RadioField = props => {
    const {fieldValue = {}, setValue} = props;

    return (
        <RadioGroup value={Boolean(fieldValue ? fieldValue.value : false)}
                    onChange={(e) => {
                        setValue(e, {label: '', value: e.target.value !== 'false'})
                    }}
                    row
        >
            <FormControlLabel value={true} control={<Radio size={"small"} color={"primary"}/>}
                              label="True"/>
            <FormControlLabel value={false} control={<Radio size={"small"} color={"primary"}/>}
                              label="False"/>
        </RadioGroup>
    )
}
export default RadioField